module.exports = __webpack_public_path__ + "media/images/employed_active-456b5616.svg";